// extracted by mini-css-extract-plugin
export var cartoon = "cartoon-module--cartoon--1BBt4";
export var left = "cartoon-module--left--2OAkK";
export var right = "cartoon-module--right--2utAu";